import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { IChangeoverPayload, IChangeoverResponse } from './changeover.model';
import { Observable } from 'rxjs';
import { BaseOneResponseInterface } from '../../../shared/model/interface/crud-response-interface.model';

@Injectable({
  providedIn: 'root',
})
export class ChangeoverService {
  constructor(
    @Inject('API_BASE_URL') private readonly baseUrl: string,
    private readonly http: HttpClient,
  ) {}

  private readonly routes = {
    changeoverChartData: `${this.baseUrl}/work-orders/changeover-chart-data`,
  };

  public getChangeoverChartData(
    payload: IChangeoverPayload,
  ): Observable<BaseOneResponseInterface<IChangeoverResponse[]>> {
    const params: HttpParams = this.getChangeoverRequestParams(payload);
    return this.http.get<BaseOneResponseInterface<IChangeoverResponse[]>>(this.routes.changeoverChartData, {
      params,
    });
  }

  private getChangeoverRequestParams(params: IChangeoverPayload): HttpParams {
    return new HttpParams()
      .set('startDate', params.startDate)
      .set('endDate', params.endDate)
      .set('siteId', params.siteId[0])
      .set('groupBy', params.groupBy)
      .set('includeUnplannedDownTimes', String(params.includeUnplannedDownTime))
      .set('lineIds', params.lines?.length ? params.lines.join(',') : '-1')
      .set('rootCauseGroupIds', params.rootCauseGroupIds?.length ? params.rootCauseGroupIds.join(',') : '-1')
      .set('useTaskTarget', String(params.useTaskTarget));
  }
}
